document.addEventListener('DOMContentLoaded', function () {
  
  // 优化弹窗显示
  const popupObserver = new MutationObserver(() => {
    const omnisendPopup = document.querySelector('#omnisend-forms-wrapper');
    if (omnisendPopup) {
      setTimeout(function () {
        omnisendPopup.classList.add('yg-init-finished');
      }, 8000);
      popupObserver.disconnect(); // 停止观察，防止重复触发
    }
  });

  // 监听整个 body
  popupObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const newImg = new Image();
          newImg.onload = () => {
            img.src = newImg.src;
            img.removeAttribute('data-src'); // 如果只需要加载一次
            img.removeAttribute('srcset');
            observer.unobserve(img); // 停止观察该元素
          };
          newImg.src = img.getAttribute('data-src');
        }
      });
    },
    {
      rootMargin: '50px' // 预加载距离视口 50px 的图片
    }
  );

  window.YGVideoLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
          // 获取内部的 template
          const template = entry.target.querySelector('template');
                
          // 将 template 的内容克隆为 DocumentFragment
          const fragment = template.content.cloneNode(true);
                
          // 先清空 yg-video 内部原有内容
          entry.target.innerHTML = '';
                
          // 将克隆的内容追加到 yg-video
          entry.target.appendChild(fragment);
      }
    });
  }, { 
    rootMargin: "200px", // 预加载距离视口 200px 的视频
  })

  class YGImage extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      // 这里放置初始化逻辑
      this.loaderImg();
    }

    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img);
      });
    }
  }
  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage);
  }

  class YGVideo extends HTMLElement {
    constructor() {
        super()
        this.init()
    }
    init() {
        // 这里放置初始化逻辑
        this.loaderVideo()
    }

    loaderVideo () {
        // 这里放置自定义逻辑
        window.YGVideoLoader.observe(this)
    }
  }
  if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo)
  }

  class YGPopupBox extends HTMLElement { 
  constructor() { 
    super(); 
    this._videoTime = null; 
    this._autoCloseTimer = null; // 添加自动关闭计时器变量
    this.addEventListener('click', (e) => { 
      this.closePopup(e, () => {}); 
    }); 
  } 

  openPopup($popupTemplate, fn) { 
    this.querySelector('.yg-popup-box-content-inner').innerHTML = 
      $popupTemplate.innerHTML; 
    this.querySelector('.yg-popup-box-header').innerHTML = $popupTemplate.getAttribute('data-header'); 
    document.body.style.overflow = 'hidden'; 
    this.style.display = 'flex'; 

    setTimeout(() => { 
      const video = this.querySelector('video'); 
      if (video) { 
        // 添加视频事件监听
        video.addEventListener('pause', this._handleVideoPause.bind(this));
        video.addEventListener('ended', this._handleVideoEnded.bind(this));
        
        if (this._videoTime !== null) { 
          video.currentTime = this._videoTime; 
          video.play(); // 自动播放恢复 
        } 
      } 
      fn(); 
    }, 30); 
  } 

  // 处理视频暂停事件
  _handleVideoPause(e) {
    const video = e.target;
    // 记录当前播放时间
    this._videoTime = video.currentTime;
    
    // 设置自动关闭计时器（例如3秒后关闭）
    if (this._autoCloseTimer) clearTimeout(this._autoCloseTimer);
    this._autoCloseTimer = setTimeout(() => {
      this.style.display = 'none';
      this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
      document.body.style.overflow = 'auto';
    }, 300);
  }

  // 处理视频播放结束事件
  _handleVideoEnded() {
    // 视频播放结束时自动关闭弹窗
    this.style.display = 'none';
    this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
    document.body.style.overflow = 'auto';
  }

  closePopup(e, fn) { 
    const target = e.target; 

    if (target.tagName === 'VIDEO') { 
      if (!target.paused) { 
        target.pause(); 
        this._videoTime = target.currentTime; 
      }
      return; // 阻止视频点击关闭弹窗
    } 

    // 清除可能存在的自动关闭计时器
    if (this._autoCloseTimer) {
      clearTimeout(this._autoCloseTimer);
      this._autoCloseTimer = null;
    }

    if ( 
      target.className === 'yg-popup-box-close' || 
      target.className === 'yg-popup-box' 
    ) { 
      this.style.display = 'none'; 
      this.querySelector('.yg-popup-box-content-inner').innerHTML = ''; 
      document.body.style.overflow = 'auto'; 
      fn(); 
    } 
  } 
} 

if (!window.customElements.get('yg-popup-box')) { 
  window.customElements.define('yg-popup-box', YGPopupBox); 
} 

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.$popupBox = document.querySelector('yg-popup-box.yg-popup-box');
    }
    init() {
      // 这里放置初始化逻辑
      this.addEventListener('click', this.itemClick.bind(this));
    }
    itemClick() {
      // 这里放置自定义逻辑
      let $popupTemplate =
        this.querySelector('template') ||
        this.querySelector('.yg-popup-template');

      $popupTemplate && this.$popupBox.openPopup($popupTemplate, () => {});
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }
  class YGSwiper extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.getAllAttributes();
      this.initSwiper();
    }

    getAllAttributes() {
      let booleanAttrs = [
        'loop',
        'pagination',
        'navigation',
        'scrollbar',
        'centeredslidesbounds',
        'centeredslides'
      ];
      let numberAttrs = [
        'initialslide',
        'slidesoffsetbefore',
        'slidesoiffsetafter'
      ];
      let jsonAttrs = ['breakpoints'];
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀

          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (numberAttrs.includes(cleanName)) {
            value = Number(value);
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints(str) {
      const result = {};
      const pairs = str.split(',');

      console.log('pairs', pairs);
      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;

        const [slides, space] = values.split('-').map(Number);

        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space
        };
      }

      console.log('result', result);
      return result;
    }

    initSwiper() {
      const swiper = new Swiper(this, {
        // 这里放置 swiper 的配置
        centeredSlides: this['centeredslides'] || false,
        centeredSlidesBounds: this['centeredslidesbounds'] || false,
        initialSlide: this['initialslide'] || 0,
        slidesoffsetbefore: this['slidesoffsetbefore'] || 0,
        slidesoiffsetafter: this['slidesoiffsetafter'] || 0,
        loop: this['loop'],
        autoplay: this['autoplay']
          ? {
              delay: this['autoplay'],
              stopOnLastSlide: false,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }
          : false,
        pagination: this['pagination']
          ? {
              el: '.swiper-pagination',
              clickable: true,
              type: 'bullets'
            }
          : false,
        scrollbar: this['scrollbar']
          ? {
              el: '.swiper-scrollbar'
            }
          : false,
        navigation: this['navigation']
          ? {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }
          : false,
        breakpoints: this['breakpoints'] ? this['breakpoints'] : false,
        // 添加事件处理
        on: {
          init: (e) => {
            if (e.passedParams.loop && e.slides.length < 4) {
              e.slides.forEach((slide) => {
                const clonedElement = slide.cloneNode(true);
                e.slidesEl.appendChild(clonedElement);
              });
            }
          }
        }
      });
    }
  }
  if (!window.customElements.get('yg-swiper')) {
    window.customElements.define('yg-swiper', YGSwiper);
  }

  class YGImageTabSwiper extends HTMLElement {
    constructor() {
      super();
      this.labelClick = this.labelClick.bind(this);

      this.$labelList = this.querySelectorAll('.yg-image-label');
      this.$contentList = this.querySelectorAll('.yg-image-content');
    }

    connectedCallback() {
      this.$labelList.forEach((label, index) => {
        label.addEventListener('click', () => this.labelClick(index));
      });
    }

    disconnectedCallback() {
      this.$labelList.forEach((label, index) => {
        label.removeEventListener('click', () => this.labelClick(index));
      });
    }

    labelClick(index) {
      // 移除所有活动状态
      this.$labelList.forEach((label) => {
        label.classList.remove('active');
      });
      this.$contentList.forEach((content) => {
        content.classList.remove('active');
      });

      // 添加新的活动状态
      this.$labelList[index].classList.add('active');
      this.$contentList[index].classList.add('active');
    }
  }

  if (!window.customElements.get('yg-image-tab-swiper')) {
    window.customElements.define('yg-image-tab-swiper', YGImageTabSwiper);
  }
  class AccordionFaq extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      this.initializeFaqItems();
      this.addEventListeners();
    }
    initializeFaqItems() {
      this.faqItems = this.querySelectorAll('.faq-container');
      this.descriptions = this.querySelectorAll('.description');
    }
    addEventListeners() {
      this.addEventListener('click', (e) => {
        const faqElement = e.target.closest('.faq-container');
        if (!faqElement) return;
        this.toggleFaq(faqElement);
      });
    }
    toggleFaq(faqElement) {
      const isActive = faqElement.classList.contains('active');

      this.closeAllFaqs();
      if (!isActive) {
        const description = faqElement.nextElementSibling;
        if (description && description.classList.contains('description')) {
          faqElement.classList.add('active');
          description.classList.add('active');
        }
      }
    }
    closeAllFaqs() {
      this.faqItems.forEach((faq) => faq.classList.remove('active'));
      this.descriptions.forEach((desc) => desc.classList.remove('active'));
    }
  }

  if (!window.customElements.get('accordion-faq')) {
    customElements.define('accordion-faq', AccordionFaq);
  }

  class YGMainMedia extends HTMLElement {
    constructor() {
      super();
      this.mainSwiper = null;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.mainSwiper = new Swiper(this.querySelector('.yg-main-swiper'), {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: this.querySelector('.yg-slide-next'),
          prevEl: this.querySelector('.yg-slide-prev')
        },
        on: {
          init: function (swiper) {
            if (swiper.params.loop && swiper.slides.length < 7) {
              const originalSlides = [...swiper.slides];
              // 克隆两次
              for (let i = 0; i < 2; i++) {
                originalSlides.forEach((slide) => {
                  const clonedElement = slide.cloneNode(true);
                  swiper.wrapperEl.appendChild(clonedElement);
                });
              }
              swiper.update(); // 更新 Swiper
            }
          }
        }
      });
    }

    getSwiper() {
      return this.mainSwiper;
    }
  }

  if (!window.customElements.get('yg-media')) {
    customElements.define('yg-media', YGMainMedia);
  }

  class YGThumbMedia extends HTMLElement {
    constructor() {
      super();
      this.thumbSwiper = null;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.thumbSwiper = new Swiper(this.querySelector('.yg-thumb-swiper'), {
        slidesPerView: 2,
        spaceBetween: 16,
        centeredSlides: true,
        centeredSlidesBounds: true,
        initialSlide: 0,
        loop: true,
        breakpoints: {
          699: {
            slidesPerView: 7,
            spaceBetween: 24
          }
        },
        on: {
          init: function (swiper) {
            if (swiper.params.loop && swiper.slides.length < 7) {
              const originalSlides = [...swiper.slides];
              // 克隆两次
              for (let i = 0; i < 2; i++) {
                originalSlides.forEach((slide) => {
                  const clonedElement = slide.cloneNode(true);
                  swiper.wrapperEl.appendChild(clonedElement);
                });
              }
              swiper.update(); // 更新 Swiper
            }
          }
        }
      });

      // 获取主轮播实例
      const mainMedia = document.querySelector('yg-media');
      const mainSwiper = mainMedia.getSwiper();

      // 设置联动
      mainSwiper.thumbs.swiper = this.thumbSwiper;
      mainSwiper.thumbs.init();

      mainSwiper.on('slideChange', () => {
        this.thumbSwiper.slideToLoop(mainSwiper.realIndex);
      });
    }
  }

  // 注册自定义元素
  if (!window.customElements.get('yg-thumb-media')) {
    customElements.define('yg-thumb-media', YGThumbMedia);
  }
});
